<template>
  <a-modal
    :open="open"
    title="Enviar apelación sobre correos masivos"
    width="500px"
    class="strategy__appeal-modal"
    @cancel="handleCancel"
  >
    <div class="appeal">
      <div class="info">
        <p>
          Complete el siguiente formulario para apelar al envío masivo de correos electrónicos.
          Recuerde que toda la información brindada será revisada y verificada por nuestros
          encargados.
        </p>
        <a-form
          class="form form__appeal"
          layout="vertical"
          ref="formRef"
          :model="formState"
          :rules="rules"
        >
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-item
                label="¿Qué método utilizó para estar seguro que sus contactos no reciban nuevamente correos masivos? "
                name="methods"
              >
                <a-checkbox-group v-model:value="formState.methods" :options="plainOptions" />
              </a-form-item>
              <a-form-item
                label="¿Qué método utiliza para recolectar los correos de sus contactos?"
                name="comment"
              >
                <a-textarea
                  v-model:value="formState.comment"
                  placeholder="Escribir aquí..."
                ></a-textarea>
              </a-form-item>
              <a-form-item name="permission">
                <a-checkbox v-model:checked="formState.agreement"
                  >* Confirmo que he revisado y gestionado los contactos que no han dado permiso
                  para recibir correos electrónicos masivos.</a-checkbox
                >
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <template #footer>
      <div class="footer">
        <div class="">
          <a-button @click="handleCancel">Cancelar</a-button>
        </div>
        <div>
          <a-button type="primary" @click="handleSubmit">Enviar apelación</a-button>
        </div>
      </div>
    </template>
  </a-modal>
  <EmailAppealSent v-model:open="openSentModal" />
</template>
<script lang="ts" setup>
import { ref, reactive, watch } from "vue";
import EmailAppealSent from "@/app/strategies/components/modals/EmailAppealSent.vue";
import { emailService } from "@/app/emails/services/Email.service";
import { FormAppealEmail } from "@/@types/emails/forms";

const props = defineProps<{ open: boolean; customChannelId: number }>();

// const checked = ref<boolean>(false);
const openSentModal = ref<boolean>(false);

const emit = defineEmits<{ "update:open": [open: boolean] }>();

const formState = reactive<FormAppealEmail>({
  channel_customer_id: props.customChannelId,
  methods: [],
  comment: null,
  agreement: false,
});

console.log(formState, "formState");

const rules = {
  methods: [{ required: true, message: "Campo requerido" }],
  comment: [{ required: true, message: "Campo requerido" }],
  agreement: [{ required: true, message: "Campo requerido" }],
};

const plainOptions = [
  "Agregó correos al módulo de desuscriptores",
  "Eliminó los correos afectados de sus contactos",
];

const handleCancel = (e: MouseEvent) => {
  console.log(e);
  emit("update:open", false);
};

const handleSubmit = async () => {
  await emailService.appealEmailSuspension(formState);
  emit("update:open", false);
  openSentModal.value = true;
};

watch(
  () => props.customChannelId,
  (newValue, oldValue) => {
    console.log("past:", oldValue);
    formState.channel_customer_id = newValue;
    console.log("Updated:", newValue, oldValue);
  }
);

watch(
  () => props.customChannelId,
  (newValue, oldValue) => {
    console.log("past:", oldValue);
    console.log("Updated:", newValue);
  }
);
</script>
<style lang="sass" scoped>
h2
  text-align: center
  margin-bottom: 20px
.strategy
  &__appeal-modal
    .appeal
      padding: 15px
    .footer
      display: flex
      justify-content: flex-end
      gap: 10px
</style>
